import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckCircleTwoTone from '@mui/icons-material/CheckCircleTwoTone';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import Check from '@mui/icons-material/Check';
import LocalActivity from '@mui/icons-material/LocalActivity';
import LocalAirport from '@mui/icons-material/LocalAirport';
import LocalAtm from '@mui/icons-material/LocalAtm';
import LocalBar from '@mui/icons-material/LocalBar';
import LocalCafe from '@mui/icons-material/LocalCafe';
import LocalCarWash from '@mui/icons-material/LocalCarWash';
import LocalConvenienceStore from '@mui/icons-material/LocalConvenienceStore';
import LocalDining from '@mui/icons-material/LocalDining';
import LocalDrink from '@mui/icons-material/LocalDrink';
import LocalFlorist from '@mui/icons-material/LocalFlorist';
import LocalGasStation from '@mui/icons-material/LocalGasStation';
import LocalGroceryStore from '@mui/icons-material/LocalGroceryStore';
import LocalHospital from '@mui/icons-material/LocalHospital';
import LocalHotel from '@mui/icons-material/LocalHotel';
import LocalLaundryService from '@mui/icons-material/LocalLaundryService';
import LocalLibrary from '@mui/icons-material/LocalLibrary';
import LocalMall from '@mui/icons-material/LocalMall';
import LocalMovies from '@mui/icons-material/LocalMovies';
import LocalOffer from '@mui/icons-material/LocalOffer';
import LocalParking from '@mui/icons-material/LocalParking';
import LocalPharmacy from '@mui/icons-material/LocalPharmacy';
import LocalPhone from '@mui/icons-material/LocalPhone';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocalPizza from '@mui/icons-material/LocalPizza';
import LocalPlay from '@mui/icons-material/LocalPlay';
import LocalPostOffice from '@mui/icons-material/LocalPostOffice';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import LocalPrintshop from '@mui/icons-material/LocalPrintshop';
import LocalSee from '@mui/icons-material/LocalSee';
import LocalShipping from '@mui/icons-material/LocalShipping';
import LocalTaxi from '@mui/icons-material/LocalTaxi';
import Festival from '@mui/icons-material/Festival';
import Park from '@mui/icons-material/Park';
import Museum from '@mui/icons-material/Museum';
import Restaurant from '@mui/icons-material/Restaurant';
import Stadium from '@mui/icons-material/Stadium';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import FormatListNumbered from '@mui/icons-material/FormatListNumbered';
import FormatListNumberedRtl from '@mui/icons-material/FormatListNumberedRtl';
import List from '@mui/icons-material/List';
import ListAlt from '@mui/icons-material/ListAlt';
import SentimentDissatisfied from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutral from '@mui/icons-material/SentimentNeutral';
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';
import SentimentVeryDissatisfied from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfied from '@mui/icons-material/SentimentVerySatisfied';
import TimeToLeave from '@mui/icons-material/TimeToLeave';
import Flight from '@mui/icons-material/Flight';
import Timer from '@mui/icons-material/Timer';
import DateRange from '@mui/icons-material/DateRange';
import Event from '@mui/icons-material/Event';
import EventSeat from '@mui/icons-material/EventSeat';
import DepartureBoard from '@mui/icons-material/DepartureBoard';
import FlightLand from '@mui/icons-material/FlightLand';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import HourglassFull from '@mui/icons-material/HourglassFull';
import HourglassTop from '@mui/icons-material/HourglassTop';
import HourglassBottom from '@mui/icons-material/HourglassBottom';
import Timeline from '@mui/icons-material/Timeline';
import Dangerous from '@mui/icons-material/Dangerous';
import CloudSync from '@mui/icons-material/CloudSync';
import SyncAlt from '@mui/icons-material/SyncAlt';
import Fingerprint from '@mui/icons-material/Fingerprint';
import Add from '@mui/icons-material/Add';
import SettingsTwoTone from '@mui/icons-material/SettingsTwoTone';
import Settings from '@mui/icons-material/Settings';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import ChecklistRtlTwoTone from '@mui/icons-material/ChecklistRtlTwoTone';
import Group from '@mui/icons-material/Group';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Person from '@mui/icons-material/Person';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import Mouse from '@mui/icons-material/Mouse';
import Description from '@mui/icons-material/Description';
import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import Logout from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import KeyboardReturn from '@mui/icons-material/KeyboardReturn';
import KeyboardControlKey from '@mui/icons-material/KeyboardControlKey';
import KeyboardCommandKey from '@mui/icons-material/KeyboardCommandKey';
import Keyboard from '@mui/icons-material/Keyboard';
import Title from '@mui/icons-material/Title';
import WatchLater from '@mui/icons-material/WatchLater';
import Verified from '@mui/icons-material/Verified';
import VerifiedTwoTone from '@mui/icons-material/VerifiedTwoTone';
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import Home from '@mui/icons-material/Home';
import Badge from '@mui/icons-material/Badge';
import AccountBox from '@mui/icons-material/AccountBox';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Toll from '@mui/icons-material/Toll';
import PunchClock from '@mui/icons-material/PunchClock';
import PunchClockOutlined from '@mui/icons-material/PunchClockOutlined';
import WorkHistory from '@mui/icons-material/WorkHistory';
import Close from '@mui/icons-material/Close';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Adjust from '@mui/icons-material/Adjust';
import SportsScore from '@mui/icons-material/SportsScore';
import Autorenew from '@mui/icons-material/Autorenew';
import Link from '@mui/icons-material/Link';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PersonRemove from '@mui/icons-material/PersonRemove';
import Inbox from '@mui/icons-material/Inbox';
import MoveToInbox from '@mui/icons-material/MoveToInbox'
import AllInbox from '@mui/icons-material/AllInbox'
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import PendingActions from '@mui/icons-material/PendingActions';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Camera from '@mui/icons-material/Camera';
import Chat from '@mui/icons-material/Chat';
import Shower from '@mui/icons-material/Shower';
import Sort from '@mui/icons-material/Sort';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Public from '@mui/icons-material/Public';
import Diversity1 from '@mui/icons-material/Diversity1';
import Menu from '@mui/icons-material/Menu';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import Cancel from '@mui/icons-material/Cancel';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import GavelIcon from '@mui/icons-material/Gavel';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import ReplayIcon from '@mui/icons-material/Replay';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SpeedIcon from '@mui/icons-material/Speed';
import NetworkPingIcon from '@mui/icons-material/NetworkPing';
import CategoryIcon from '@mui/icons-material/Category';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import CelebrationIcon from '@mui/icons-material/Celebration';
import GroupsIcon from '@mui/icons-material/Groups';
import InsightsIcon from '@mui/icons-material/Insights';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import StarIcon from '@mui/icons-material/Star';
import StorefrontIcon from '@mui/icons-material/Storefront';
import InventoryIcon from '@mui/icons-material/Inventory';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ComputerIcon from '@mui/icons-material/Computer';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import Bed from '@mui/icons-material/Bed';
import PersonOutline from '@mui/icons-material/PersonOutline';
import Edit from '@mui/icons-material/Edit';
import DirectionsRun from '@mui/icons-material/DirectionsRun';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import Brightness7OutlinedIcon from '@mui/icons-material/Brightness7Outlined';
import EditCalendar from '@mui/icons-material/EditCalendar';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MessageIcon from '@mui/icons-material/Message';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import AlarmIcon from '@mui/icons-material/Alarm';
import SendIcon from '@mui/icons-material/Send';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import RingVolumeIcon from '@mui/icons-material/RingVolume';
import RingVolumeOutlinedIcon from '@mui/icons-material/RingVolumeOutlined';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import TrafficIcon from '@mui/icons-material/Traffic';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import PhonelinkIcon from '@mui/icons-material/Phonelink';
import SecurityIcon from '@mui/icons-material/Security';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import PasswordIcon from '@mui/icons-material/Password';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import HistoryIcon from '@mui/icons-material/History';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import BallotIcon from '@mui/icons-material/Ballot';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import KeyIcon from '@mui/icons-material/Key';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import DnsIcon from '@mui/icons-material/Dns';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import StorageIcon from '@mui/icons-material/Storage';
import WebIcon from '@mui/icons-material/Web';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CottageTwoToneIcon from '@mui/icons-material/CottageTwoTone';
import CopyrightIcon from '@mui/icons-material/Copyright';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import FlagCircleOutlinedIcon from '@mui/icons-material/FlagCircleOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import VideoChatOutlinedIcon from '@mui/icons-material/VideoChatOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import RampLeftOutlinedIcon from '@mui/icons-material/RampLeftOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AssistantOutlinedIcon from '@mui/icons-material/AssistantOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import RecentActorsOutlinedIcon from '@mui/icons-material/RecentActorsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FiberNewOutlinedIcon from '@mui/icons-material/FiberNewOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import DraftsIcon from '@mui/icons-material/Drafts';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';

const IconMap = {
    'CheckCircle': CheckCircle,
    'CheckCircleTwoTone': CheckCircleTwoTone,
    'CheckCircleOutlineOutlined': CheckCircleOutlineOutlined,
    'Check': Check,
    'LocalActivity': LocalActivity,
    'LocalAirport': LocalAirport,
    'LocalAtm': LocalAtm,
    'LocalBar': LocalBar,
    'LocalCafe': LocalCafe,
    'LocalCarWash': LocalCarWash,
    'LocalConvenienceStore': LocalConvenienceStore,
    'LocalDining': LocalDining,
    'LocalDrink': LocalDrink,
    'LocalFlorist': LocalFlorist,
    'LocalGasStation': LocalGasStation,
    'LocalGroceryStore': LocalGroceryStore,
    'LocalHospital': LocalHospital,
    'LocalHotel': LocalHotel,
    'LocalLaundryService': LocalLaundryService,
    'LocalLibrary': LocalLibrary,
    'LocalMall': LocalMall,
    'LocalMovies': LocalMovies,
    'LocalOffer': LocalOffer,
    'LocalParking': LocalParking,
    'LocalPharmacy': LocalPharmacy,
    'LocalPhone': LocalPhone,
    'LocalPhoneOutlined': LocalPhoneOutlinedIcon,
    'LocalPizza': LocalPizza,
    'LocalPlay': LocalPlay,
    'LocalPostOffice': LocalPostOffice,
    'LocalPostOfficeOutlined': LocalPostOfficeOutlinedIcon,
    'LocalPrintshop': LocalPrintshop,
    'LocalSee': LocalSee,
    'LocalShipping': LocalShipping,
    'LocalTaxi': LocalTaxi,
    'Festival': Festival,
    'Park': Park,
    'Museum': Museum,
    'Restaurant': Restaurant,
    'Stadium': Stadium,
    'FormatListBulleted': FormatListBulleted,
    'FormatListNumbered': FormatListNumbered,
    'FormatListNumberedRtl': FormatListNumberedRtl,
    'List': List,
    'ListAlt': ListAlt,
    'SentimentDissatisfied': SentimentDissatisfied,
    'SentimentNeutral': SentimentNeutral,
    'SentimentSatisfied': SentimentSatisfied,
    'SentimentVeryDissatisfied': SentimentVeryDissatisfied,
    'SentimentVerySatisfied': SentimentVerySatisfied,
    'TimeToLeave': TimeToLeave,
    'Flight': Flight,
    'Timer': Timer,
    'DateRange': DateRange,
    'Event': Event,
    'EventSeat': EventSeat,
    'DepartureBoard': DepartureBoard,
    'FlightLand': FlightLand,
    'HourglassEmpty': HourglassEmpty,
    'HourglassFull': HourglassFull,
    'HourglassTop': HourglassTop,
    'HourglassBottom': HourglassBottom,
    'Timeline': Timeline,
    'Dangerous': Dangerous,
    'CloudSync': CloudSync,
    'SyncAlt': SyncAlt,
    'Fingerprint':  Fingerprint,
    'Add': Add,
    'SettingsTwoTone': SettingsTwoTone,
    'Settings': Settings,
    'SettingsOutlined': SettingsOutlined,
    'ChecklistRtlTwoTone': ChecklistRtlTwoTone,
    'Group': Group,
    'GroupOutlined': GroupOutlinedIcon,
    'Person': Person,
    'PersonAdd': PersonAdd,
    'PersonRemove': PersonRemove,
    'AdminPanelSettings': AdminPanelSettings,
    'Mouse': Mouse,
    'Description': Description,
    'DarkMode': DarkMode,
    'LightMode': LightMode,
    'LightModeOutlined': LightModeOutlined,
    'Logout': Logout,
    'Login': LoginIcon,
    'KeyboardReturn': KeyboardReturn,
    'KeyboardControlKey': KeyboardControlKey,
    'KeyboardCommandKey': KeyboardCommandKey,
    'Keyboard': Keyboard,
    'Title': Title,
    'WatchLater': WatchLater,
    'Verified': Verified,
    'VerifiedTwoTone': VerifiedTwoTone,
    'VerifiedOutlined': VerifiedOutlined,
    'Home': Home,
    'Badge': Badge,
    'AccountBox': AccountBox,
    'AccountCircle': AccountCircle,
    'Toll': Toll,
    'PunchClock': PunchClock,
    'PunchClockOutlined': PunchClockOutlined,
    'WorkHistory': WorkHistory,
    'Close': Close,
    'ArrowDropDown': ArrowDropDown,
    'Adjust': Adjust,
    'SportsScore': SportsScore,
    'Autorenew': Autorenew,
    'Link': Link,
    'Inbox': Inbox,
    'MoveToInbox': MoveToInbox,
    'AllInbox': AllInbox,
    'AssignmentInd': AssignmentInd,
    'PendingActions': PendingActions,
    'HistoryOutlined': HistoryOutlined,
    'ArrowBack': ArrowBack,
    'Camera': Camera,
    'Chat': Chat,
    'Shower': Shower,
    'Sort': Sort,
    'Visibility': Visibility,
    'VisibilityOff': VisibilityOff,
    'Public': Public,
    'Diversity1': Diversity1,
    'Menu': Menu,
    'AddCaller': AddIcCallIcon,
    'Cancel': Cancel,
    'PhoneDisabled': PhoneDisabledIcon,
    'ArrowForwardIos': ArrowForwardIosIcon,
    'SettingsBrightness': SettingsBrightnessIcon,
    'ContentCopy': ContentCopyIcon,
    'Notifications': NotificationsIcon,
    'NotificationsNone': NotificationsNoneIcon,
    'ContactPage': ContactPageIcon,
    'ArrowDownward': ArrowDownwardIcon,
    'ArrowUpward': ArrowUpwardIcon,
    'Gavel': GavelIcon,
    'MenuBook': MenuBookIcon,
    'Business': BusinessIcon,
    'AssignmentLate': AssignmentLateIcon,
    'TipsAndUpdates': TipsAndUpdatesIcon,
    'Replay': ReplayIcon,
    'GroupAdd': GroupAddIcon,
    'CalendarMonth': CalendarMonthIcon,
    'Speed': SpeedIcon,
    'NetworkPing': NetworkPingIcon,
    'Category': CategoryIcon,
    'Upgrade': UpgradeIcon,
    'ReadMore': ReadMoreIcon,
    'Celebration': CelebrationIcon,
    'Groups': GroupsIcon,
    'Insights': InsightsIcon,
    'WbTwilight': WbTwilightIcon,
    'Star': StarIcon,
    'Storefront': StorefrontIcon,
    'Inventory': InventoryIcon,
    'PublishedWithChanges': PublishedWithChangesIcon,
    'MailOutline': MailOutlineIcon,
    'Computer': ComputerIcon,
    'PersonPin': PersonPinIcon,
    'LockPerson': LockPersonIcon,
    'Lock': LockIcon,
    'LockOpen': LockOpenIcon,
    'ThumbUpAlt': ThumbUpAltIcon,
    'ThumbUpOffAlt': ThumbUpOffAltIcon,
    'ThumbDownAlt': ThumbDownAltIcon,
    'ThumbDownOffAlt': ThumbDownOffAltIcon,
    'Bed': Bed,
    'PersonOutline': PersonOutline,
    'Edit': Edit,
    'DirectionsRun': DirectionsRun,
    'CancelOutlined': CancelOutlined,
    'Download': DownloadIcon,
    'AttachFile': AttachFileIcon,
    'Attachment': AttachmentIcon,
    'CloudUpload': CloudUploadIcon,
    'CloudDone': CloudDoneIcon,
    'CloudDoneOutlined': CloudDoneOutlinedIcon,
    'Brightness7Outlined': Brightness7OutlinedIcon,
    'EditCalendar': EditCalendar,
    'SupportAgent': SupportAgentIcon,
    'Message': MessageIcon,
    'ChatBubbleOutline': ChatBubbleOutlineIcon,
    'AssignmentTurnedInOutlined': AssignmentTurnedInOutlinedIcon,
    'ContactMail': ContactMailIcon,
    'ContactMailOutlined': ContactMailOutlinedIcon,
    'AdminPanelSettingsOutlined': AdminPanelSettingsOutlinedIcon,
    'Manager': AdminPanelSettingsOutlinedIcon,
    'PersonSearchOutlined': PersonSearchOutlinedIcon,
    'ManageSearchOutlined': ManageSearchOutlinedIcon,
    'Alarm': AlarmIcon,
    'Send': SendIcon,
    'ForwardToInboxOutlined': ForwardToInboxOutlinedIcon,
    'PhoneForwarded': PhoneForwardedIcon,
    'PhoneForwardedOutlined': PhoneForwardedOutlinedIcon,
    'RingVolume': RingVolumeIcon,
    'RingVolumeOutlined': RingVolumeOutlinedIcon,
    'VolumeUp': VolumeUpIcon,
    'VolumeMute': VolumeMuteIcon,
    'VolumeDown': VolumeDownIcon,
    'VolumeOff': VolumeOffIcon,
    'TrafficOutlined': TrafficOutlinedIcon,
    'Traffic': TrafficIcon,
    'AttachMoney': AttachMoneyIcon,
    'ReceiptLong': ReceiptLongIcon,
    'AccessTime': AccessTimeIcon,
    'Time': AccessTimeIcon,
    'Project': CheckCircleOutlineOutlined,
    'EmojiPeople': EmojiPeopleIcon,
    'Phonelink': PhonelinkIcon,
    'Security': SecurityIcon,
    'Email': ContactMailIcon,
    'LabelImportant': LabelImportantIcon,
    'Password': PasswordIcon,
    'TipsAndUpdatesOutlined': TipsAndUpdatesOutlinedIcon,
    'KeyOutlined': KeyOutlinedIcon,
    'Sunrise': Brightness7OutlinedIcon,
    'LocationCity': LocationCityIcon,
    'PersonOff': PersonOffIcon,
    'MarkunreadMailboxOutlined': MarkunreadMailboxOutlinedIcon,
    'History': HistoryIcon,
    'CardMembership': CardMembershipIcon,
    'PersonSearch': PersonSearchIcon,
    'Ballot': BallotIcon,
    'BallotOutlined': BallotOutlinedIcon,
    'SpaceDashboardOutlined': SpaceDashboardOutlinedIcon,
    'ContactPageOutlined': ContactPageOutlinedIcon,
    'ContactSupportOutlined': ContactSupportOutlinedIcon,
    'ContactsOutlined': ContactsOutlinedIcon,
    'PersonPinOutlined': PersonPinOutlinedIcon,
    'Key': KeyIcon,
    'ReceiptOutlined': ReceiptOutlinedIcon,
    'SourceOutlined': SourceOutlinedIcon,
    'AlternateEmailOutlined': AlternateEmailOutlinedIcon,
    'EmailOutlined': EmailOutlinedIcon,
    'InfoOutlined': InfoOutlinedIcon,
    'DnsOutlined': DnsOutlinedIcon,
    'DetailsOutlined': DnsOutlinedIcon,
    'Dns': DnsIcon,
    'Details': DnsIcon,
    'FormatSize': FormatSizeIcon,
    'SupportOutlined': SupportOutlinedIcon,
    'ArchiveOutlined': ArchiveOutlinedIcon,
    'KeyboardArrowRight': KeyboardArrowRightIcon,
    'DeleteOutlineOutlined': DeleteOutlineOutlinedIcon,
    'CalendarMonthOutlined': CalendarMonthOutlinedIcon,
    'ConnectWithoutContact': ConnectWithoutContactIcon,
    'Storage': StorageIcon,
    'Web': WebIcon,
    'DragHandle': DragHandleIcon,
    'CottageTwoTone': CottageTwoToneIcon,
    'Copyright': CopyrightIcon,
    'HistoryToggleOff': HistoryToggleOffIcon,
    'SwapVert': SwapVertIcon,
    'FlagCircleOutlined': FlagCircleOutlinedIcon,
    'AutoStoriesOutlined': AutoStoriesOutlinedIcon,
    'VideoChatOutlined': VideoChatOutlinedIcon,
    'LocalShippingOutlined': LocalShippingOutlinedIcon,
    'FormatListBulletedOutlined': FormatListBulletedOutlinedIcon,
    'AccountBalanceOutlined': AccountBalanceOutlinedIcon,
    'LeaderboardOutlined': LeaderboardOutlinedIcon,
    'GroupsOutlined': GroupsOutlinedIcon,
    'MapOutlined': MapOutlinedIcon,
    'WatchLaterOutlined': WatchLaterOutlinedIcon,
    'PushPinOutlined': PushPinOutlinedIcon,
    'LocationOn': LocationOnIcon,
    'LocationOnOutlined': LocationOnOutlinedIcon,
    'AssignmentOutlined': AssignmentOutlinedIcon,
    'AssistantOutlined': AssistantOutlinedIcon,
    'SupervisedUserCircleOutlined': SupervisedUserCircleOutlinedIcon,
    'RecentActorsOutlined': RecentActorsOutlinedIcon,
    'AssessmentOutlined': AssessmentOutlinedIcon,
    'KeyboardArrowUp': KeyboardArrowUpIcon,
    'KeyboardArrowDown': KeyboardArrowDownIcon,
    'CancelScheduleSend': CancelScheduleSendIcon,
    'Drafts': DraftsIcon,
    'AdsClick': AdsClickIcon,
    'ScheduleSend': ScheduleSendIcon,


    'DayOnesEmail': EmailOutlinedIcon,
    'DayOnesChat': AlternateEmailOutlinedIcon,
    'DayOnesPhone': LocalPhoneOutlinedIcon,
    'DayOnesCalendar': CalendarMonthOutlinedIcon,
    'DayOnesTeam': GroupsOutlinedIcon,
    'DayOnesPerformance': LeaderboardOutlinedIcon,
    'DayOnesPayroll': AccountBalanceOutlinedIcon,
    'DayOnesParcel': LocalShippingOutlinedIcon,
    'DayOnesRoadmap': RampLeftOutlinedIcon,
    'DayOnesProject': FormatListBulletedOutlinedIcon,
    'DayOnesSecurity': GppGoodOutlinedIcon,
    'DayOnesSales': AttachMoneyIcon,
    'DayOnesSupport': SupportAgentIcon,
    'DayOnesNotes': ArticleOutlinedIcon,
    'DayOnesClockIn': PunchClock,
    'DayOnesClockOut': PunchClockOutlined,
    'DayOnesDelay': WatchLaterOutlinedIcon,
    'DayOnesReport': AssessmentOutlinedIcon,
    'DayOnesNew': FiberNewOutlinedIcon,

    'DayOnesListOpen': AssignmentOutlinedIcon,
    'DayOnesMentor': AssistantOutlinedIcon,
    'DayOnesDedicated': SupervisedUserCircleOutlinedIcon,

    'DayOnesPitch': CoPresentOutlinedIcon,


};
export default IconMap;
